import React, { lazy, Suspense} from "react";

import DefaultLoader from "../utilities/loaders/DefaultLoader";
const MembershipTiersContent = lazy(() => import('./MembershipTiersContent'));



const MembershipTiers = () => {
    return (  
        <Suspense fallback={<DefaultLoader />}>
            <MembershipTiersContent />
        </Suspense>
    );
}

export default MembershipTiers;